<div class="form-modal" style="width: 700px">
  <h1 mat-dialog-title>{{ parameters.ModalTitle | translate}}</h1>
  <div mat-dialog-content >
    <div class="row form-horizontal">

      <div class="col-sm-12">
        <div class="panel panel-default">
          <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#divHistoric"
            (click)="changeShrink()">
            <h5 class="panel-title">
              <i class="fas fa-tasks"></i>
              <strong>{{ 'HISTORY' | translate}}&nbsp;&nbsp;</strong>
              <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': shrink , 'fa-caret-up': !shrink }"></i>
            </h5>
            <div id="divHistoric" class="panel-body collapse px-1" [ngClass]="{'in': openHistoryByDefault }" (click)="$event.stopPropagation()">
              <div class="table-responsive">
                <div class="col-lg-12 col-md-12 col-sm-12 px-1">
                  <table id="tableHistory" class="table table-bordered display" cellspacing="0">
                    <thead>
                      <tr>
                        <th></th>
                        <th>
                          <strong>{{ 'DATE' | translate }}</strong>
                        </th>
                        <th>
                          <strong>{{ 'FROM' | translate }}</strong>
                        </th>
                        <th>
                          <strong>{{ 'TO' | translate }}</strong>
                        </th>
                        <th>
                          <strong>{{ 'DONE_BY' | translate }}</strong>
                        </th>
                        <th>
                          <strong>{{ 'OBS_ABBREVIATION' | translate }}</strong>
                        </th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="!hideChangeStates">
        <div class="col-sm-12" *ngIf="!canChangeStates">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup1"
              (click)="collPnPopup1 = !collPnPopup1">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'STATE_CHANGE' | translate}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': collPnPopup1, 'fa-caret-up': !collPnPopup1}"></i>
              </h5>
            </div>
            <div id="collPnPopup1" class="panel-body no-horizontal-padding collapse in">
              <!-- se ja foi buscar os estados mas nao tem nenhum-->
              <div *ngIf="canChangeStates==false" class="text-center">
                <span>{{'NO_STATE_TO_CHANGE' | translate}}</span>
              </div>
              <!-- se ainda nao tiver ido buscar os estados que pode alterar -->
              <div *ngIf="canChangeStates==null" class="text-center">
                <i class="fas fa-spinner fa-spin fa-3x fa-fw"></i>
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>

        <!-- ja tem os estados -->
        <form [formGroup]="form" *ngIf="canChangeStates">
          <div class="col-sm-12">
            <div class="panel panel-default">
              <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup2"
                (click)="collPnPopup2 = !collPnPopup2">
                <h5 class="panel-title">
                  <i class="fas fa-tasks"></i>
                  <strong>{{ 'STATE_CHANGE' | translate}}</strong>
                  <i class="collapse-icon fas"
                    [ngClass]="{'fa-caret-down': collPnPopup2, 'fa-caret-up': !collPnPopup2}"></i>
                </h5>
              </div>
              <div id="collPnPopup2" class="panel-body no-horizontal-padding collapse in">
                <div class="form-group">
                  <!-- Estados -->
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <mat-radio-group (change)="validateState($event)" class="custom-radio-group" formControlName="StepID" style="display:inline" *ngIf="this.context === 'Process'">
                      <mat-radio-button *ngFor="let step of steps; let i=index" class="custom-radio-button"
                        [value]="step.ID">
                        {{step.Name}}</mat-radio-button>
                    </mat-radio-group>
                    <mat-radio-group (change)="validateState($event)" class="custom-radio-group" formControlName="StepID" style="display:inline" *ngIf="this.context !== 'Process'">
                      <mat-radio-button *ngFor="let step of steps; let i=index" class="custom-radio-button"
                        [value]="step.ID">
                        {{step.ActionVerb}}</mat-radio-button>
                    </mat-radio-group>
                    <span *ngIf="formErrors.Steps" class="field-validation-valid text-danger" [translate]>{{ formErrors.Steps
                  }}</span>
                  </div>
                  <!-- Observações -->
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <mat-form-field class="allwidth">
                      <mat-label>{{ 'OBSERVATIONS' | translate}}</mat-label>
                      <textarea matInput formControlName="Notes"
                        class="no-resize" rows="3"></textarea>
                    </mat-form-field>
                    <error [control]="form.get('Notes')"></error>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </ng-container>




      <!-- Atribuir permissão de estados a outros utilizadores -->
      <div class="col-sm-12" *ngIf="steps && steps.length > 0 && users && users.length > 0">
        <div class="panel panel-default">
          <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup3"
            (click)="collPnPopup3 = !collPnPopup3">
            <h5 class="panel-title">
              <i class="fas fa-tasks"></i>
              <strong>{{ 'ASSIGN_ACTIONS_TO_ANOTHER_USER' | translate}}&nbsp;&nbsp;</strong>
              <i class="collapse-icon fas"
                [ngClass]="{'fa-caret-down': collPnPopup3, 'fa-caret-up': !collPnPopup3}"></i>
            </h5>
          </div>
          <div id="collPnPopup3" class="panel-body no-horizontal-padding collapse in">
            <div class="form-group">
              <div class="col-sm-6">
                <mat-form-field class="full-width">
                  <mat-label>{{'USERNAME'|translate}}</mat-label>
                  <mat-select [(ngModel)]="selectedUser">
                    <mat-select-header class="device-select-header">
                      <mat-form-field class="col-sm-12 md-select-search">
                        <mat-label>{{'SEARCH'|translate}}</mat-label>
                        <input matInput #search type="text">
                        <i matSuffix class="fas fa-search"></i>
                      </mat-form-field>
                    </mat-select-header>
                    <mat-option></mat-option>
                    <mat-option *ngFor="let item of users | mdSelectContainsPipe:['Name', search.value]"
                      [value]="item.ID">{{
                    item.Name }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-sm-6">
                <button type="button" class="btn btn-primary" title="{{'ASSIGN' | translate}}"
                  (click)="addStepsApprover()" [disabled]="!selectedUser">
                  {{'ASSIGN' | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <div class="full-width text-right modal-theme">
        <button type="button" class="btn btn-default" title="{{'CLOSE' | translate}}" (click)="dialogRef.close(null)">
          {{'CLOSE' | translate}}
        </button>
        <button *ngIf="canChangeStates" type="button" class="btn btn-primary" title="{{'BUTTON.CHANGE' | translate}}"
          (click)="save()">
          {{'BUTTON.CHANGE' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>